import { IScope } from "@nju/scope";
import { IChooseNewNumberFormType } from "./../types";

interface ITextData {
  text: string;
}

interface IGetChooseNewNumberTextDataProps {
  flow: IChooseNewNumberFormType;
  variant?: IScope;
}

export function getChooseNewNumberTextData({
  flow,
  variant,
}: IGetChooseNewNumberTextDataProps): ITextData | undefined {
  if (
    (flow === "NEW_NUMBER" || flow === "CHANGE_NUMBER") &&
    variant !== "sales"
  ) {
    return {
      text: "wybierz nowy numer",
    };
  }

  if (flow === "NEW_NUMBER" && variant === "sales") {
    return {
      text: "wybierz nowy numer dla klienta",
    };
  }

  return undefined;
}
